import { render, staticRenderFns } from "./comp_ProductsCarouselSection.vue?vue&type=template&id=bd7584c2&"
import script from "./comp_ProductsCarouselSection.vue?vue&type=script&lang=js&"
export * from "./comp_ProductsCarouselSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports